import Skeleton from "@/components/skeleton/Skeleton";
import { fadeDownOpacity } from "@/components/skeleton/skeleton.utils";

import styles from "./ConsecutiveDaysSkeleton.module.scss";

type Props = {
  cardCount?: number;
  isMini?: boolean;
};

const ConsecutiveDaysSkeleton = ({ cardCount = 7, isMini }: Props) => {
  return (
    <div className={`${styles.container} ${isMini ? styles.containerMini : ""}`}>
      <div className={styles.dayGrid}>
        {Array.from({ length: cardCount }, (_, index) => (
          <Skeleton
            key={index}
            className={styles.dayCardSkeleton}
            style={{ opacity: fadeDownOpacity(index) }}
          />
        ))}
      </div>
      <Skeleton className={styles.streakSkeleton} />
    </div>
  );
};

export default ConsecutiveDaysSkeleton;
